const setSubProperty = function(crop, value) {
  let prop = this;
  try {
    if (value && Object.prototype.toString.call(value) == "[object String]") {
      value = JSON.parse(value);
    }
  } catch (e) { value = null; }
  if (!value || Object.keys(value).length==0) {
    value = {
      undefined_date: [{formula:null}]
    };
  }
  let what = prop.name=='fertilizer' ? 'ปุ๋ย' : 'สารเคมี';
  let hasData = false;
  let v = [{
    group: prop.alias,
    properties: []
  }];
  let date;
  for (let p in value) {
    date = {
      name: 'date',
      alias: 'วันที่ใส่' + what,
      ctrlType: 'date',
      value: p.match(/undefined_date|null/i) ? null : p
    };
    v[0].properties.push(date);
    hasData = false;
    if (value[p]) {
      let formula = {
        name: prop.name,
        alias: 'รายการ' + what,
        ctrlType: 'property',
        value: [{
          //group: 'รายการ' + what,
          properties: []
        }]
      };
      value[p].forEach((item) => {
        for (let d in item) {
          if (d=='formula' && !!item[d]) {
            formula.value[0].properties.push({
              name: d,
              alias: d,
              value: item[d]
            });
            hasData = true;
          }
        }
      });
      if (hasData) {
        v[0].properties.push(formula);
      }
    }
  }
  prop.value = v;
}
export default {
  title: 'ข้อมูลแปลงปลูก',
  items: [{
      group: 'ที่ตั้งแปลงและการเพาะปลูก',
      properties: [{
          name: 'gid',
          alias: 'รหัส Geometry',
          ctrlType: 'hidden'
        },{
          name: 'province',
          alias: 'จังหวัด'
        },{
          name: 'amphoe',
          alias: 'อำเภอ'
        },{
          name: 'tambon',
          alias: 'ตำบล'
        },{
          name: 'village',
          alias: 'หมู่บ้าน'
        },{
          name: 'remark',
          alias: 'ชื่อจุด/หมายเหตุ',
        },{
          name: 'area_sqm',
          alias: 'เนื้อที่จากแผนที่',
          suffix: '(ตร.ม.)'
        },{
          name: 'area_rai_ngan_sqwah',
          alias: 'เนื้อที่จากแผนที่'
        },{
          name: 'deed_rai_ngan_sqwah',
          alias: 'เนื้อที่ตามเอกสาร'
        },{
          name: 'farm_rai_ngan_sqwah',
          alias: 'เนื้อที่ปลูก'
        },{
          name: 'type_fk_g',
          alias: 'ประเภทพืช',
          ctrlType: 'select',
          dataType: 'integer',
          options: [],
          loadOptions: async function(user) {
            this.user = user;
            this.options = await user.requestResource('codelist/crop_types');
          },
          onOptionChange: function(properties) {
            properties[12].options = [];
            properties[11].fetchOptions(this.user, this.value);
          }
        },{
          name: 'genus_fk_g',
          alias: 'ชนิดพืช',
          isMandatory: true,
          ctrlType: 'select',
          dataType: 'integer',
          options: [],
          fetchOptions: async function(user, value) {
            this.user = user;
            this.options = await user.requestResource('codelist/crop_genera/' + value);
          },
          onOptionChange: function(properties) {
            properties[12].fetchOptions(this.user, this.value);
          }
        },{
          name: 'crop_fk_g',
          alias: 'พันธุ์พืช',
          ctrlType: 'select',
          dataType: 'integer',
          fetchOptions: async function(user, value) {
            this.user = user;
            this.options = await user.requestResource('codelist/crop_species/' + value);
          }
        },{
          name: 'wrsc_fk',
          alias: 'ประเภทแหล่งน้ำ',
          ctrlType: 'select',
          dataType: 'integer',
          options: [{
            code: 10,
            name: 'ระบบชลประทาน'
          }, {
            code: 20,
            name: 'แหล่งน้ำธรรมชาติ'
          }, {
            code: 30,
            name: 'น้ำฝน'
          }, {
            code: 40,
            name: 'น้ำประปา'
          }, {
            code: 50,
            name: 'น้ำบาดาล'
          }]
        },{
          name: 'deed_type_g',
          alias: 'ประเภทเอกสารสิทธิ์',
          ctrlType: 'select',
          dataType: 'text',
          options: [],
          loadOptions: async function(user) {
            this.user = user;
            this.options = await user.requestResource('codelist/deed_types');
          },
        },{
          name: 'deed_no_g',
          alias: 'เลขที่เอกสารสิทธิ์',
          dataType: 'text'
        },{
          name: 'land_nth',
          alias: 'ที่ดินแปลงที่',
          placeholder: 'ตัวเลข',
          dataType: 'integer'
        },{
          name: 'ownership',
          alias: 'ความเป็นเจ้าของ',
          ctrlType: 'select',
          dataType: 'text',
          options:[
            {code:'ของตนเอง',name:'ของตนเอง'},
            {code:'ที่เช่า',name:'ที่เช่า'}
          ]
        }]
    },{
      group: 'สภาพแปลงตามกายภาพ',
      properties: [{
          name: 'soil_fk',
          alias: 'สภาพดิน'
        },{
          name: 'suitability',
          alias: 'ความเหมาะสมของดิน',
          ctrlType: 'property',
          loadOptions: async function(user, gid, template) {
            let data;
            try {
              data = await user.requestResource('mis/land_suitability/' + gid);
            } catch (error) {}
            let v = Object.assign({},template);
            if (data) {
              data.forEach((d) => {
                v[d.crop] = d.suitability;
              });
            }
            this.value = [{
              group: this.alias,
              properties: []
            }];
            for (let p in v) {
              this.value[0].properties.push({
                name: p,
                alias: p,
                value: v[p]
              });
            }
          }
        },{
          name: 'flooded_year',
          alias: 'ปีที่เกิดอุทกภัย',
          loadOptions: async function(user, gid) {
            let data;
            try {
              data = await user.requestResource('mis/land_flooded_year/' + gid);
            } catch (error) {}
            if (data) {
              this.value = data[0].flooded_year;
            }
          }
        },{
          name: 'irrigation',
          alias: 'เขตชลประทาน'
        },{
          name: 'alro_area',
          alias: 'เขต ส.ป.ก.'
        },{
          name: 'in_conserved',
          alias: 'ทับซ้อนเขตป่า',
          ctrlType: 'textarea',
          highlight: true,
        }]
    },{
      group: 'การประเมินผลผลิต',
        properties: [{
          name: 'fid',
          ctrlType: 'hidden',
          dataType: 'number'
        },{
          name: 'grow_dt',
          alias: 'วันที่ปลูก ',
          ctrlType: 'date'
        },{
          name: 'plant_age',
          alias: 'อายุพืช (ปี)'
        },{
          name: 'blossom_dt',
          alias: 'วันที่ออกดอก',
          ctrlType: 'date',
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'harvest_dt',
          alias: 'วันที่เริ่มเก็บเกี่ยว',
          ctrlType: 'date'
        },{
          name: 'harvest_days',
          alias: 'รอบวันเก็บเกี่ยว',
          suffix: '(วัน)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'tree_space',
          alias: 'ระยะห่างระหว่างต้น',
          suffix: '(ม.)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'row_space',
          alias: 'ระยะห่างระหว่างแถว',
          suffix: '(ม.)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'trees_pr',
          alias: 'จำนวนต้น/ไร่',
          suffix: '(ต้น/ไร่)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if ((crop.type_fk_g==24) || 
                ((crop.type_fk_g==25) && (crop.genus_fk_g==250110))) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'trees_total',
          alias: 'จำนวนต้นทั้งหมด',
          suffix: '(ต้น)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if ((crop.type_fk_g==24) || 
                ((crop.type_fk_g==25) && (crop.genus_fk_g!=250110))) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'canopy_size',
          alias: 'ขนาดทรงพุ่ม',
          ctrlType: 'select',
          dataType: 'text',
          options: [{
            code:'ใหญ่',name:'ขนาดใหญ่'
          },{
            code:'ปานกลาง',name:'ขนาดปานกลาง'
          },{
            code:'เล็ก',name:'ขนาดเล็ก'
          }],
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'bouquet_pt',
          alias: 'จำนวนช่อดอก/ต้น',
          suffix: '(ดอก/ต้น)',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          name: 'fertilizer',
          alias: 'การใช้ปุ๋ย',
          ctrlType: 'property',
          setProperty(crop, value) {
            setSubProperty.call(this, crop, value);
          }
        },{
          name: 'catalyzer',
          alias: 'การใช้สารเคมีเร่งผลผลิต',
          ctrlType: 'property',
          setProperty(crop, value) {
            setSubProperty.call(this, crop, value);
          }
        },{
          name: 'pesticide',
          alias: 'การใช้สารเคมีป้องกันโรคแมลง',
          ctrlType: 'property',
          setProperty(crop, value) {
            setSubProperty.call(this, crop, value);
          }
        },{
          name: 'standards',
          alias: 'มาตรฐาน',
          ctrlType: 'property',
          setProperty(crop, value) {
            if (value && Object.prototype.toString.call(value) == "[object String]") {
              value = JSON.parse(value);
            }
            this.originalValue = value || null;
            value = value || {};
            let v = {};
            if (crop.genus_fk_g=='250110') {
              v.rspo = (value.rspo!=undefined) ? value.rspo : null;
            } else {
              ['gap','organicFood'].forEach((p) => {
                v[p] = value[p]!=undefined ? value[p] : null;
              });
            }
            this.value = [{
              group: this.alias,
              properties: []
            }];
            for (let p in v) {
              this.value[0].properties.push({
                name: p,
                alias: p,
                ctrlType: 'radio',
                dataType: 'boolean',
                options: [
                  {code:1,name:'ใช่'},
                  {code:0,name:'ไม่ใช่'}
                ],
                value: v[p]===true ? 1 : v[p]===false ? 0 : null
              });
            }
          }
        },{
          name: 'standard_others',
          alias: 'มาตรฐานอื่นๆ'
        },{
          alias: 'ราคาสายพันธุ์',
          suffix: '(บาท/ต้น)',
          name: 'cost_breed_bpt',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          alias: 'ต้นทุนการปลูก',
          suffix: '(บาท/ไร่)',
          name: 'cost_growing_bpr',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          alias: 'ต้นทุนการผลิต',
          suffix: '(บาท/ไร่/ปี)',
          name: 'cost_growing_bpr',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          alias: 'ผลผลิต',
          suffix: '(ตัน/ไร/ปี)',
          name: 'production_tpry',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.genus_fk_g==250110) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          alias: 'ผลผลิตที่',
          suffix: '(ตัน)',
          name: 'production_ton',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'ผลผลิตเกรดดีมาก/AA',
          suffix: '(ตัน)',
          name: 'production_aa',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'ผลผลิตเกรดดี/A',
          suffix: '(ตัน)',
          name: 'production_a',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'ผลผลิตเกรดพอใช้/B',
          suffix: '(ตัน)',
          name: 'production_b',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'ผลผลิตเกรดต่ำกว่ามาตรฐาน/C',
          suffix: '(ตัน)',
          name: 'production_c',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'ราคาผลผลิต',
          suffix: '(บาท/กก.)',
          name: 'price_bpkg',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.genus_fk_g==250110) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'การจำหน่ายผลผลิต',
          name: 'market',
          ctrlType: 'radio',
          dataType: 'text',
          options: [
            {code:'เหมา',name:'เหมา'},
            {code:'ขายสด',name:'ขายสด'}
          ]
        },{
          alias: 'แหล่งรับซื้อ',
          name: 'buyer',
          dataType: 'text'
        },{
          alias: 'จำนวนพื้นที่เสียหาย',
          suffix: '(ไร่)',
          name: 'lost_area',
          dataType: 'decimal',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = 'hidden';
            } else {
              this.ctrlType = undefined;
            }
          }
        },{
          alias: 'จำนวนที่เสียหาย',
          suffix: '(ต้น)',
          name: 'lost_trees',
          dataType: 'integer',
          placeholder: 'ตัวเลข',
          setProperty(crop) {
            if (crop.type_fk_g==24 || crop.type_fk_g==25) {
              this.ctrlType = undefined;
            } else {
              this.ctrlType = 'hidden';
            }
          }
        },{
          alias: 'สาเหตุที่เสียหาย',
          name: 'lost_cause',
          dataType: 'text'
        },{
          alias: 'ระดับความเสียหาย',
          name: 'lost_claim',
          ctrlType: 'select',
          dataType: 'text',
          options: [
            {code:'เสียหายมาก', name:'เสียหายมาก'},
            {code:'เสียหายปานกลาง', name:'ปานกลาง'},
            {code:'เสียหายเล็กน้อย', name:'เล็กน้อย'},
            {code:'ไม่มีความเสียหาย', name:'ไม่มีความเสียหาย'},
            {code:'', name:'ไม่ทราบ'}
          ]
        },{
          alias: 'วันที่บันทึกข้อมูล',
          name: 'edit_ts_g',
          ctrlType: 'date'
        }]
    }]
};
